﻿import { useParams, useNavigate } from "react-router-dom";
import { ShoppingCart, History } from "lucide-react";

import { useIntegrationForm } from "@/hooks/integrations/useIntegrationForm";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";
import CustomInfoMessage from "@/components/desktop/list/CustomInfoMessage";

import { base_object } from "../integrations.constants";
import IntegrationFields from "./IntegrationFields";
import CustomButton from "@/components/desktop/button/CustomButton";

const IntegrationForm = ({ filters }) => {
	const navigate = useNavigate();
	const { option, element_id } = useParams();

	const onClose = () => {
		setFormErrors({});
		clearInfoMessages();
		navigate("/configuracion/integraciones");
	};

	const {
		isOpen,
		modalTitle,
		isLoadingSave,
		isLoadingElement,
		isLoadingExcel,
		isFetchingElement,
		formState,
		setFormState,
		formErrors,
		setFormErrors,
		infoMessages,
		messageType,
		clearInfoMessages,
		handleSubmit,
		handleExcel,
	} = useIntegrationForm({
		option,
		filters,
		elementId: element_id,
		baseObject: base_object,
		onClose,
	});

	if (!isOpen) return null;

	const isLoading = isLoadingSave || isLoadingElement || isFetchingElement || isLoadingExcel;

	return (
		<CustomModalForm
			open={isOpen}
			onClose={onClose}
			title={modalTitle}
			size="xl"
			asForm
			onSubmit={handleSubmit}
			isLoading={isLoading}
			gridTable={false}
			footerLeft={
				<>
					<CustomButton
						variant="secondary"
						disabled={isLoading}
						startIcon={<ShoppingCart size={16} />}
						onClick={() => navigate("/configuracion/integraciones/compras/" + element_id)}
					>
						Ver Compras
					</CustomButton>
					<CustomButton
						variant="secondary"
						disabled={isLoading}
						startIcon={<History size={16} />}
						onClick={() => navigate("/configuracion/integraciones/aplicaciones/" + element_id)}
					>
						Ver Aplicaciones
					</CustomButton>
				</>
			}
		>
			{infoMessages.length > 0 && <CustomInfoMessage messages={infoMessages} type={messageType} autoCloseDuration={30000} onClose={clearInfoMessages} />}

			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<IntegrationFields
					formState={formState}
					setFormState={setFormState}
					formErrors={formErrors}
					setFormErrors={setFormErrors}
					handleExcel={handleExcel}
				/>
			)}
		</CustomModalForm>
	);
};

export default IntegrationForm;
